<div class="checkin__booking__detail__payments__header"
  [ngClass]="{ 'checkin__booking__detail__payments__header--extra__bottom' : payments?.sorted?.value[0]?.selected }">
  <span class="checkin__sidebar__item__subtitle">{{ 'payments-detail' | translate }}</span>
  <ng-container *ngIf="payments?.sorted?.value?.length <= 1" [ngTemplateOutlet]="showMore"></ng-container>
</div>
<div class="checkin__booking__detail__payments__list">
  <app-payments-detail-item *ngFor="let payment of payments?.sorted?.value" [payment]="payment" [ngClass]="{ 'selected': payment?.selected }">
  </app-payments-detail-item>
</div>
<ng-container *ngIf="payments?.sorted?.value?.length > 1" [ngTemplateOutlet]="showMore"></ng-container>

<app-slide-out *ngIf="slider?.show" [preventClose]="false" [slideOutType]="slider?.type"
  [animationState]="slider?.animation" (closeSlideOut)="closeSlideOutHandler()">
  <app-payments-slideout [payments]="payments?.all" (closeSlideOut)="closeSlideOutHandler()">
  </app-payments-slideout>
</app-slide-out>

<ng-template #showMore>
  <app-button-secondary *ngIf="payments?.showMore" [ngClass]="cta__prevent__hide" [text]="'display-payments'"
    (click)="openSlideOutHandler()">
  </app-button-secondary>
</ng-template>
